<template>
    <div>
        <div class="top_unit_comment">
            <div class="top_name_box position_relate">
              <div class="mgb_10" style="display: flex;justify-content: space-between;">
                {{brandStoreName}}
                <div v-if="!isStoreManager">
                  アラート通知
                  <input type="checkbox" name="checkbox02" id="monthlyCheckAlert" v-model="data.isAlert" :value="1">
                  <label class="checkbox02" for="monthlyCheckAlert"></label>
                </div>
              </div>責任者：{{managerName}}
            </div>
            <div v-if="errorText || validationErrorText">
                <Message :validationMessage="alertMessage" />
            </div>
            <div class="monthly_report">
                <div class="textarea_unit wd876 mgt_15">
                    <p class="text-danger font-weight-bold text_white_space_pre_wrap">{{errorText}}</p>
                    <p class="text-danger font-weight-bold text_white_space_pre_wrap">{{alertMessage}}</p>
                </div>
                <div v-if="!isLoading" class="textarea_unit wd876 mgt_15">
                    <p class="textarea_name">店舗管理者
                        <span class="mgl_20">本日最終確認 {{storeManagerCommentDatetime}} </span>
                        <span class="mgl_20">当月最終確認 {{storeManagerLastMonthCommentDatetime}} </span>
                    </p>
                    <textarea v-model="data.monthlyCheck.comment.storeManager.comment" :disabled="!isStoreManager" class="textarea_box2" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                    <p v-if="isStoreManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
                    <div v-if="data.commentHistoryFlg.staffHistoryFlg" class="right_icn3">
                        <router-link :to="{ name: 'monthlyCheckReportHistoryIndex',
                            params:{ year, month, day, manager: 1}}" target='_blank' rel="noopener noreferrer">
                                <p class="icn_blue"><i class="fas fa-history"></i></p> 
                        </router-link>
                    </div>
                </div>
                <div v-if="!isLoading"  class="textarea_unit wd876 mgt_15">
                    <p class="textarea_name">企業管理者
                        <span class="mgl_20">本日最終確認 {{companyManagerCommentDatetime}} </span>
                        <span class="mgl_20">当月最終確認 {{companyManagerLastMonthCommentDatetime}} </span>
                        <span v-if="data.monthlyCheck.comment.companyManager.reportCommentAlert == 0" style="float: right;color: red">店舗未対応</span>
                        <span v-if="data.monthlyCheck.comment.companyManager.reportCommentAlert == 1" style="float: right;color: blue">店舗対応済み:{{data.monthlyCheck.comment.companyManager.staffName}}</span>
                    </p>
                    <textarea v-model="data.monthlyCheck.comment.companyManager.comment" :disabled="!isCompanyManager" class="textarea_box2" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                    <p v-if="isCompanyManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
                    <div v-if="data.commentHistoryFlg.companyHistoryFlg" class="right_icn3">
                        <router-link :to="{ name: 'monthlyCheckReportHistoryIndex',
                            params:{ year, month, day, manager: 2}}" target='_blank' rel="noopener noreferrer">
                                <p class="icn_blue"><i class="fas fa-history"></i></p> 
                        </router-link>
                    </div>
                </div>
                <div v-if="!isLoading"  class="textarea_unit wd876 mgt_15">
                    <p class="textarea_name">その他管理者
                        <span class="mgl_20">本日最終確認 {{otherManagerCommentDatetime}} </span>
                        <span class="mgl_20">当月最終確認 {{otherManagerLastMonthCommentDatetime}} </span>
                        <span v-if="data.monthlyCheck.comment.otherManager.reportCommentAlert == 0" style="float: right;color: red">店舗未対応</span>
                        <span v-if="data.monthlyCheck.comment.otherManager.reportCommentAlert == 1" style="float: right;color: blue">店舗対応済み:{{data.monthlyCheck.comment.otherManager.staffName}}</span>
                    </p>
                    <textarea v-model="data.monthlyCheck.comment.otherManager.comment" :disabled="!isOtherManager" class="textarea_box2" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                    <p v-if="isOtherManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
                    <div v-if="data.commentHistoryFlg.otherHistoryFlg" class="right_icn3">
                        <router-link :to="{ name: 'monthlyCheckReportHistoryIndex',
                            params:{ year, month, day, manager: 3}}" target='_blank' rel="noopener noreferrer">
                                <p class="icn_blue"><i class="fas fa-history"></i></p> 
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">CSV出力</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>CSV出力が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isCsvLoading">
            <pulse-loader class="w-100 text-center" :loading="isCsvLoading"></pulse-loader>
        </div>
    </div>
    
</template>

<script>
    export default {
        name: 'MonthlyCheckReport',
        props: {
            data: {
                type: Object,
                required: true,
            },
            errorText: {
                type: String
            },
            validationErrorText: {
                type: String
            },
            isLoading: {
                type: Boolean
            },
            selectDate:{
                type: String
            },
            year:{
                type: Number
            },
            month:{
                type: Number
            },
            day:{
                type: Number
            },
            topButtonNo: {
                type: Number,
                required: true
            },
        },
        data: function () {
            return {
                storeManagerComment: "",
                companyManagerComment: "",
                otherManagerComment: "",
                showContent: false,
                isCsvLoading:false,
                addFormFlg:true,
                alertMessage:"",
                storeManagerCommentDatetime: '',
                companyManagerCommentDatetime: '',
                otherManagerCommentDatetime: '',
                storeManagerLastMonthCommentDatetime: '',
                companyManagerLastMonthCommentDatetime: '',
                otherManagerLastMonthCommentDatetime: '',
            }
        },
        created() {
            this.storeManagerComment = this.data.monthlyCheck.comment.storeManager.comment;
            this.companyManagerComment = this.data.monthlyCheck.comment.companyManager.comment
            this.otherManagerComment = this.data.monthlyCheck.comment.otherManager.comment
            this.lastUpdateTimeStore()
            this.lastUpdateTimeCompany()
            this.lastUpdateTimeOther()
            this.lastMonthlyUpdateTimeStore()
            this.lastMonthlyUpdateTimeCompany()
            this.lastMonthlyUpdateTimeOther()
        },
        computed: {
            managerName: function () {
                return this.$store.getters['store/adminName']
            },
            role: function () {
                return Number(this.$store.getters['manager/manager'].authorityKbn)
            },
            isStoreManager: function () {
                return this.role === 4
            },
            isCompanyManager: function () {
                return this.role === 2
            },
            isOtherManager: function () {
                return this.role === 6
            },
            brandStoreName: function () {
                let brandName = this.$store.getters['brand/name']
                let storeName = this.$store.getters['store/name']

                if (brandName == null) {
                    brandName = ''
                }

                if (storeName == null) {
                    storeName = ''
                }

                return brandName + '・' + storeName
            },
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
         },
        methods: {
            checkComent(){
                // コメントの差分をチェックする
                if(this.storeManagerComment !== this.data.monthlyCheck.comment.storeManager.comment ||
                    this.companyManagerComment !== this.data.monthlyCheck.comment.companyManager.comment ||
                    this.otherManagerComment !== this.data.monthlyCheck.comment.otherManager.comment){

                    // 親のコメントフラグを書き換える
                    this.$parent.commentFlg = true;
                }
                else{
                    this.$parent.commentFlg = false;
                }
            },
            async csvExport(){

                this.addFormFlg = true;
                this.isCsvLoading = true;
                this.alertMessage = "";
                var buttonNo = 99;

                var params = {
                    start_date: this.selectDate, end_date:this.selectDate
                };

                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/id'];

                // API呼び出し
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/daily/' + this.topButtonNo + '/' + buttonNo ,{params})
                    .then(response => (this.csvResponseData = response))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        this.addFormFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);
                            if (err.customError.code == 401) {
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                            if(error.code == 400){
                                this.alertMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isCsvLoading = false);

                if(this.addFormFlg){
                    // CSV出力
                    if(!this.commonDownloadCSV(this.csvResponseData)){
                        this.alertMessage =  "CSVの出力に失敗しました。";
                        this.addFormFlg = false;
                        this.scrollTop();
                    }
                    else{
                        this.showContent = true;
                    }
                }
                this.$emit('complete');
            },
            closeModel(){
                this.showContent = false;
            },
            scrollTop() {
                window.scrollTo(0, 0);
            },
            formatLastUpdateTime: function (lastUpdateTime) {
                lastUpdateTime = lastUpdateTime.replace(/-/g, '/')
                lastUpdateTime = lastUpdateTime.slice( 0, -3 )
                return lastUpdateTime
            },
            lastUpdateTimeStore: function () {
                if(this.data.monthlyCheck.comment.storeManager.commentsDatetime !== "") {
                    this.storeManagerCommentDatetime = this.formatLastUpdateTime(this.data.monthlyCheck.comment.storeManager.commentsDatetime)
                } else {
                    this.storeManagerCommentDatetime = '-'
                }
            },
            lastUpdateTimeCompany: function () {
                if(this.data.monthlyCheck.comment.companyManager.commentsDatetime !== "") {
                    this.companyManagerCommentDatetime = this.formatLastUpdateTime(this.data.monthlyCheck.comment.companyManager.commentsDatetime)
                } else {
                    this.companyManagerCommentDatetime = '-'
                }
            },
            lastUpdateTimeOther: function () {
                if(this.data.monthlyCheck.comment.otherManager.commentsDatetime !== "") {
                    this.otherManagerCommentDatetime = this.formatLastUpdateTime(this.data.monthlyCheck.comment.otherManager.commentsDatetime)
                } else {
                    this.otherManagerCommentDatetime = '-'
                }
            },
            lastMonthlyUpdateTimeStore: function () {
                if(this.data.lastDatetime.storeManager.commentsDatetime !== "") {
                    this.storeManagerLastMonthCommentDatetime = this.formatLastUpdateTime(this.data.lastDatetime.storeManager.commentsDatetime)
                } else {
                    this.storeManagerLastMonthCommentDatetime = '-'
                }
            },
            lastMonthlyUpdateTimeCompany: function () {
                if(this.data.lastDatetime.companyManager.commentsDatetime !== "") {
                    this.companyManagerLastMonthCommentDatetime = this.formatLastUpdateTime(this.data.lastDatetime.companyManager.commentsDatetime)
                } else {
                    this.companyManagerLastMonthCommentDatetime = '-'
                }
            },
            lastMonthlyUpdateTimeOther: function () {
                if(this.data.lastDatetime.otherManager.commentsDatetime !== "") {
                    this.otherManagerLastMonthCommentDatetime = this.formatLastUpdateTime(this.data.lastDatetime.otherManager.commentsDatetime)
                } else {
                    this.otherManagerLastMonthCommentDatetime = '-'
                }
            },
            updateUserCommentDatetime(){
                if (this.isStoreManager) {
                    this.lastUpdateTimeStore()
                    this.lastMonthlyUpdateTimeStore()
                } else if (this.isCompanyManager) {
                    this.lastUpdateTimeCompany()
                    this.lastMonthlyUpdateTimeCompany()
                } else {
                    this.lastUpdateTimeOther()
                    this.lastMonthlyUpdateTimeOther()
                }
            },
        },
        watch: {
            topButtonNo (key) {
                if (key) {
                    this.csvExport()
                }
            },
        }
    }
</script>
